

























import {
  Vue,
  Watch,
  Component,
  Prop
} from "@/shared/vuepack";

@Component
export default class Input extends Vue {
  @Prop()
  id: string;

  @Prop()
  name: string;

  @Prop()
  classes: string[];

  @Prop([String, Number])
  value: string | number;

  @Prop()
  mask: string;

  @Prop()
  label: string;

  @Prop()
  tooltipMessage: string;

  @Prop()
  type: string;

  @Prop()
  autocomplete: string;

  @Prop()
  placeholder: string;

  @Prop()
  minValue: number;

  @Prop()
  maxValue: number;

  @Prop()
  maxlength: number;

  @Prop()
  stepValue: number;

  @Prop()
  invalid: boolean;

  @Prop()
  disabled: boolean;

  @Prop()
  focusOnMount: boolean;

  onUpdate (value) {
    // this was firing extra events
    // when vue was templating the input (the element value being set).
    // Code here is to supress an update when the value is unchanged
    const propValueString = this.stringOrEmpty(this.value);
    if (value !== propValueString) {
      this.$emit("input", value);
       return;
    }
  }

  stringOrEmpty (original) {
    // handle cases that will throw an error instead of returning a string
    return (typeof(original) === "undefined" || original === null) ?
        "" : original.toString();
  }

  mounted () {
    if (this.focusOnMount) {
      const actuallyAnHtmlElement: any = this.$refs.theInput;
      actuallyAnHtmlElement.focus();
    }
  }

  onEnter () {
    this.$emit("enter");
  }
}
